import React from 'react';
import styled, { withTheme } from 'styled-components'
import Chart from 'react-apexcharts';

import { Box } from 'vqp-common'
import { CardTitle } from './'

const getDefaultChartOptions = (theme) => ({
    chart: {
        toolbar: {
            show: false
        },
        offsetY: 12
    },
    dataLabels: {
        enabled: true
    },
    plotOptions: {
        heatmap: {
            colorScale: {
                ranges: [
                    { from: 0, to: 0, color: '#f0f0f0', name: '0' },
                    { from: 1, to: 2, color: theme?.colors?.lightGreen || '#7dd3a8', name: '1-2' },
                    { from: 3, to: 5, color: theme?.colors?.success || '#119C4A', name: '3-5' },
                    { from: 6, to: 100, color: theme?.colors?.primary || '#173A6D', name: '6+' }
                ]
            }
        }
    },
    legend: {
        position: 'top',
        offsetY: 12,
        horizontalAlign: 'center'
    },
    xaxis: {
        position: 'top',
        labels: {
            offsetY: -20
        },
        tooltip: {
            enabled: false
        },
        tickAmount: 'dataPoints'
    },
    tooltip: {
        enabled: true
    }
})

const Wrapper = styled.div``

export const HeatMap = withTheme( ({title, data, theme}) => {
    const chartOptions = getDefaultChartOptions(theme);

    const safeData = (Array.isArray(data) ? data : []).filter(Boolean);
    const chartSeries = safeData.map(dataset => ({
        name: dataset?.label ?? '',
        data: Array.isArray(dataset?.data) ? dataset.data : [],
    }))

    const hasValidSeries = chartSeries.length > 0 && chartSeries.every(s => Array.isArray(s?.data));

    return (
        <Wrapper>
            <CardTitle>{title}</CardTitle>
            <Box padding={"20px"}>
                {hasValidSeries ? (
                    <Chart
                        options={chartOptions}
                        series={chartSeries}
                        type={'heatmap'}
                        height={290}
                    />
                ) : null}
            </Box>
        </Wrapper>
    )
})